import React from 'react';

var instance:Util = null;

export class Util extends React.Component {

    constructor() {
        super({});

        if (!instance) {
            instance = this;
        }

        return instance;
    }

    getSrcUrl = (srcUrl:any) => {
        if (srcUrl === "mainMaster") {
            return "memo/master";
        }
        else
        if (srcUrl === "mainMasterField") {
            return "memo/masterField";
        }
        else
        if (srcUrl === "format") {
            return "memo/format";
        }
        else
        if (srcUrl === "approvalMatrix") {
            return "main/approvalMatrix";
        }
        else
        if (srcUrl === "userProfile") {
            return "main/userProfile";
        }
        
        return srcUrl;
    }

    getKeyValue = (key: string) => (obj: Record<string, any>) => obj[key]

    BG_FIELD = (inps:any, name:string) => {
        return this.getKeyValue(name)(inps)
    }

    getNodeRefStr = (nodeRef:string) => {

        return nodeRef ? nodeRef.replace("://","/") : ""
    }

    isSafari = () => {
        return navigator.vendor.match(/apple/i) &&
            !navigator.userAgent.match(/crios/i) &&
            !navigator.userAgent.match(/fxios/i) &&
            !navigator.userAgent.match(/Opera|OPT\//);
    }

    getLabelMap = (s:string) => {

        var label = s
        var type = "l"

        if (s?.startsWith("<html>")) {
            type = "h"
            label = s.substring(6)
            if (label.endsWith("</html>")) {
                label = label.substring(0, label.length-7)
            }
        }

        // console.log("  label:"+label)
        // console.log("  type:"+type)

        return {
            type:type,
            label:label
        }
    }

    getValidFile = (f:any) => {

        if (this.isSafari()) {
            const name = f.name
            if (name.startsWith("image.") && name.length<=10) {
              const pos = name.lastIndexOf(".")
              const ext = name.slice((pos - 1 >>> 0) + 2);
              const pre = name.substring(0, pos)
              const newName = pre + "_" + (new Date()).toJSON().replace(/[-TZ:.]/g,"")
              return new File([f], newName + "." + ext)
            }
        }

        return f
    }

    getVersion = () => {
        return "000411";
    }

    render():any {
        return (null);
    }

}

export default Util;
